<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">If We Could</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author"><b>About the Author</b></a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication"><b>Dedication</b></a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information"><b>Copyright Information ©</b></a></li>
<li id="toc-li-4"><span href="#/text/ch004#part-1" title="Link target outside of Sample"><b>Part 1</b>:<em>Accepting the Crowd’s Response?</em></span><ol class="toc"><li id="toc-li-5"><span href="#/text/ch004#accepting-the-crowds-response" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-6"><span href="#/text/ch005#part-2" title="Link target outside of Sample"><b>Part 2</b>:<em>Educating Others</em></span><ol class="toc"><li id="toc-li-7"><span href="#/text/ch005#educating-others" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-8"><span href="#/text/ch006#part-3" title="Link target outside of Sample"><b>Part 3</b>: <em>Is There a Problem?</em></span><ol class="toc"><li id="toc-li-9"><span href="#/text/ch006#is-there-a-problem" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-10"><span href="#/text/ch007#part-4" title="Link target outside of Sample"><b>Part 4</b>: <em>Can I Solve My Own Problem?</em></span><ol class="toc"><li id="toc-li-11"><span href="#/text/ch007#can-i-solve-my-own-problem" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-12"><span href="#/text/ch008#part-5" title="Link target outside of Sample"><b>Part 5</b>:<em>Managers to Rethink About Their Roles</em></span><ol class="toc"><li id="toc-li-13"><span href="#/text/ch008#managers-to-rethink-about-their-roles" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-14"><span href="#/text/ch009#part-6" title="Link target outside of Sample"><b>Part 6</b>: <em>Going Back to the Role of HR</em></span><ol class="toc"><li id="toc-li-15"><span href="#/text/ch009#going-back-to-the-role-of-hr" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-16"><span href="#/text/ch010#part-7" title="Link target outside of Sample"><b>Part 7</b>: <em>Moved On and Lost Talent</em></span><ol class="toc"><li id="toc-li-17"><span href="#/text/ch010#moved-on-and-lost-talent" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-18"><span href="#/text/ch011#part-8" title="Link target outside of Sample"><b>Part 8</b>: <em>Is the Termination Letter Ready?</em></span><ol class="toc"><li id="toc-li-19"><span href="#/text/ch011#is-the-termination-letter-ready" title="Link target outside of Sample"></span></li>
</ol></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?0c0b76bf